/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './Components/Table';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import CardHeader from '../../../components/CardHeader';
import { AcademicYear } from './AcademicYearSlice';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import EmptyAddScreen from '../../../components/EmptyAddScreen';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';

const ManageAcademicYearList = () => {
    const { setToastmessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const AcademicYearList = useSelector(state => state.AcademicYearSlice);
    const { List } = AcademicYearList
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [isRole, setIsRole] = useState(false)
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        // setLoading(true);
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getInstitutionUsers = useCallback(async () => {
        try {
            setLoading(true); 
            const branch_id = await GetBranchId()
            dispatch(AcademicYear(searchParams, branch_id)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0 ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found.");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            handleLoadData()
            setLoading(false);
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    /* `useEffect(() => { getInstitutionUsers(); }, [getInstitutionUsers]);` is a hook that is used to run
    the `getInstitutionUsers` function whenever the `getInstitutionUsers` function changes. In this case,
    the `getInstitutionUsers` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getInstitutionUsers` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        getUserRole();
        getInstitutionUsers();
    }, [searchParams]);

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`users/reset-password/${confirmationState.item.email_address}`:`users/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true,
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Institution user ${state} successfully`);
            }
            handleConformationClick();
            setLoading(true)
            getBranch();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setLoading(true)
            // setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    const getUserRole = async() => {
        const user = await CognitoData();
        if(user.idToken.payload["custom:user_type"] === "institution-admin" || user.idToken.payload["custom:user_type"] === "institution-user") 
        {
            setIsRole(false)
        }else{
            setIsRole(true)
        }
    }

    return (
        <>
            <CardHeader noPadding >
                <TopBarWithShadow
                    AddButton={!isRole}
                    SearchInput={false}
                    Tittle={'Academic Years'}
                    AddButtonName={'Add Academic Year'}
                    SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                    handleOnClickSearch={handleSearchParams}
                    isClick='/manage-academic-years/add-new-academic-year'
                    
                /> <CardHeader body >
                    {loading ? <ItemShimmer />
                        : <>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                setLoading={setLoading}
                                isRole={isRole}
                            />
                            {(List.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </>
                    }</CardHeader>
            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Institution User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for this user ?` : `${confirmationState.status} ${confirmationState.item.first_name} ${confirmationState.item.last_name} ?`}`}
                        buttonName = {confirmationState.status === 'Reset Password' ? "Reset" : confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default ManageAcademicYearList;
